// Libs
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

// Selectors
import { operation$ } from 'hfty-orders'

// Component
import Checkout from 'hfty-checkout/src/components/Checkout'

const mapStateToProps = (state) => ({
  operation: operation$(state),
})

const mapDispatchToProps = {
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout)
